module.exports = __webpack_public_path__ + "img/locator.e91cdc2.png";